import { Box, Flex, Text, Icon, Heading, Button } from "@chakra-ui/react";
import {
  AvailabilityColorSchemeEnum,
  AvailabilityEnum,
} from "../../constant/enums";
import { VscCircleFilled } from "react-icons/vsc";

import { ShowListProps } from "../../@types/ShowList";
import { DateSelector } from "../DateSelector";

function ShowList_1({ onDateChange, screens }: ShowListProps) {
  return (
    <Box background="primary.200" mt="1rem" pt="2.5rem" px="1rem" pb="1rem">
      <Flex
        mb="1rem"
        direction={{
          base: "column",
          md: "row",
        }}
        alignItems="center"
        justifyContent="space-between"
      >
        <Flex
          mb={{
            base: "1rem",
            md: 0,
          }}
          alignItems="center"
          gap="0.25rem"
        >
          {(
            Object.keys(AvailabilityEnum) as Array<
              keyof typeof AvailabilityEnum
            >
          ).map((key, index) => (
            <Flex
              alignItems="center"
              justifyContent="center"
              fontWeight="bold"
              key={`availabilty__${index}`}
            >
              <Box display="inline-flex">
                <Icon
                  mb={0}
                  color={AvailabilityEnum[key]}
                  fontSize={{
                    base: "xl",
                    md: "2xl",
                  }}
                  aria-label="circle_icon"
                  as={VscCircleFilled}
                />
              </Box>
              <Text
                fontSize={{
                  base: "xs",
                  md: "sm",
                }}
                mb={0}
                textTransform="capitalize"
              >
                {key.toString().replaceAll("_", " ").toLowerCase()}
              </Text>
            </Flex>
          ))}
        </Flex>
        <DateSelector onDateChange={onDateChange} />
      </Flex>

      {screens.map((screen, index) => (
        <Flex
          backgroundColor="blackAlpha.100"
          borderRadius="10px"
          overflow="hidden"
          key={`screen__${index}`}
          alignItems="center"
          gap="1rem"
          direction={{
            base: "column",
            md: "row",
          }}
        >
          <Box
            width={{
              base: "100%",
              md: "max-content",
            }}
            textAlign="center"
            background="primary.500"
            color="white"
            p="1.5rem"
            px="1.5rem"
          >
            <Heading as="h4" size="md">
              {screen.name}
            </Heading>
            <Text>{screen.location}</Text>
          </Box>
          <Flex
            p="1rem"
            wrap="wrap"
            alignItems={{
              base: "center",
              md: "flex-start",
            }}
            flex={1}
            gap="1rem"
          >
            {screen.shows.map((show, showIndex) => (
              <Button
                borderRadius="5px"
                key={`show_${showIndex}`}
                colorScheme={
                  show.show_status === "fast-filling"
                    ? AvailabilityColorSchemeEnum.FAST_FILLING
                    : show.show_status === "sold-out"
                      ? AvailabilityColorSchemeEnum.SOLD_OUT
                      : show.show_status === "no-available"
                        ? AvailabilityColorSchemeEnum.NOT_AVAILABLE
                        : show.isAvailable
                          ? AvailabilityColorSchemeEnum.AVAILABLE
                          : "info.500"
                }
              >
                {show.startTime}
              </Button>
            ))}
          </Flex>
        </Flex>
      ))}
    </Box>
  );
}

export default ShowList_1;
